import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

type TDisbursementChannelResponse = {
  data: {
    data: {
      id: number;
      channel_name: string;
    }[];
  };
};

const getDisbursementChannels = async () => {
  const data = await getData(ajaxEndpoints.GET_DISBURSEMENT_CHANNEL_LIST);

  return data;
};

export default function useDisbursementChannels() {
  return useQuery<TDisbursementChannelResponse>(
    "getDisbursementChannels",
    getDisbursementChannels,
    {
      refetchOnWindowFocus: false,
    }
  );
}
